<template>
  <div class="d-flex flex-wrap justify-start align-start">
    <div
      class="d-flex justify-space-between align-center pa-2 slot-add-container"
    >
      <v-select
        :items="indexes"
        :label="$t('slot.slotIndex')"
        v-model="index"
        prepend-inner-icon="mdi-counter"
        :style="slotAndKeys ? 'max-width: 125px;' : ''"
        style="margin-right: 0.5rem"
      />

      <v-autocomplete
        v-if="slotAndKeys"
        :items="tagKeysMapped"
        item-text="labelAndKey"
        item-value="key"
        v-model="key"
        :label="$t('tagdata.fields.key')"
        :hint="$t('slot.addHint')"
        persistent-hint
        prepend-inner-icon="mdi-broadcast"
        :filter="customFilter"
      />

      <v-text-field
        v-else
        v-model="slotDescription"
        :label="$t('slot.slotDescription')"
        prepend-inner-icon="mdi-label"
      />

      <v-btn icon @click="addSlotWithKey" color="green"
        ><v-icon>mdi-plus</v-icon></v-btn
      >
    </div>

    <!-- 
      Reset all slots
      <div class="slot-reset-container mt-2 mb-4">
      <v-btn @click="resetSlots" color="accent"
        ><v-icon>mdi-redo</v-icon> {{ $t("slot.resetSlots") }}</v-btn
      >
    </div> -->

    <div
      v-for="(tp, i) in storeSlots"
      :key="i"
      @click="addOrRemoveSlot(tp.index, tp.key, tp.slotDescription)"
      :class="`d-flex jusitfy-start align-center widget-type-container ${
        isSelected(tp.index, tp.key, tp.slotDescription) ? 'selected-type' : ''
      }`"
      style="position: relative"
    >
      <v-btn
        v-if="isSelected(tp.index, tp.key) && false"
        x-small
        absolute
        top
        right
        icon
        color="error"
        ><v-icon>mdi-delete</v-icon></v-btn
      >
      <v-icon
        class="pa-2"
        large
        :color="
          isSelected(tp.index, tp.key, tp.slotDescription) ? 'primary' : ''
        "
        >mdi-form-select</v-icon
      >
      <div
        class="d-flex flex-column justify-center align-start overflow-hidden"
        style="width: 100%; height: 100%"
      >
        <span class="overline title-type-text">{{ tp.slot }}</span>
        <span class="caption">{{
          slotDistinction(tp.key, tp.slotDescription)
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { useSlotAndKeys } from "../../_helpers/templateDashboardHelper.js";
import { templateDashboardTypes } from "../../_helpers/templateDashboardHelper.js";

export default {
  name: "SlotSelector",

  props: {
    slots: {
      default: () => [],
    },

    dashboardType: {
      type: Number,
      default: 1,
    },
  },

  model: { prop: "slots" },

  data() {
    return { key: "", index: 1, indexes: [1], slotDescription: "" };
  },

  methods: {
    ...mapActions("slots", ["addSlot", "resetSlots"]),
    ...mapActions("tag", ["getAllKeys"]),

    addOrRemoveSlot(index, key, slotDescription) {
      var sltIdx = this.localSlots.findIndex(
        (d) =>
          d.key == key &&
          d.slotDescription == slotDescription &&
          d.index == index
      );
      if (sltIdx !== -1) {
        this.$emit("removeSlotMeta", this.localSlots[sltIdx].slotId);
        this.localSlots.splice(sltIdx, 1);
        return;
      }

      this.localSlots.push({
        ...this.getSlot(index, key, slotDescription),
        slotId: crypto.randomUUID(),
      });
    },

    addSlotWithKey() {
      if (this.slotAndKeys) {
        if (this.key == undefined || this.key === "") return;
      } else {
        if (this.slotDescription == undefined || this.slotDescription === "") {
          this.slotDescription = this.slotAndKeys ? this.key : this.index;
        }
        this.key = this.slotDescription;
      }

      this.addSlot({
        index: this.index,
        key: this.key,
        slotDescription: this.slotDescription,
      });

      if (
        this.widgetOrDashboardTypeCanHaveMoreThanOneSlotIndex &&
        this.index == this.indexes.length
      )
        this.indexes.push(this.indexes.length + 1);
    },

    isSelected(index, key, slotDescription) {
      var sltIdx = this.localSlots.findIndex(
        (d) =>
          d.key == key &&
          d.slotDescription == slotDescription &&
          d.index == index
      );
      return sltIdx !== -1;
    },

    slotDistinction(key, slotDescription) {
      return this.slotAndKeys
        ? this.$t("slot.slotKey") + `: ${key}`
        : this.$t("slot.slotDescription") + `: ${slotDescription}`;
    },

    customFilter(item, queryText, itemText) {
      let qLower = queryText.toLowerCase();
      return (
        (item.key !== undefined && item.key.toLowerCase().includes(qLower)) ||
        itemText.toLowerCase().includes(qLower)
      );
    },
  },

  computed: {
    ...mapState("slots", { storeSlots: "slots" }),
    ...mapState("tag", { tagKeys: "keys" }),
    ...mapGetters("slots", ["getSlot"]),

    widgetOrDashboardTypeCanHaveMoreThanOneSlotIndex() {
      return this.dashboardType == this.dashboardTypes.Full?.value;
    },

    slotAndKeys() {
      return useSlotAndKeys(this.dashboardType);
    },

    dashboardTypes: () => templateDashboardTypes,

    tagKeysMapped() {
      return this.tagKeys.map((d) => {
        return {
          ...d,
          labelAndKey: d.label + " - " + d.key,
        };
      });
    },

    localSlots: {
      get() {
        return this.slots;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },

  async created() {
    await this.getAllKeys();
  },

  watch: {
    storeSlots(val) {
      if (val === undefined) return;
      if (!this.widgetOrDashboardTypeCanHaveMoreThanOneSlotIndex) {
        this.indexes = [1];
        return;
      }

      // Get the highest index from storeSlots
      let maxIndex = 0;
      this.storeSlots.forEach((d) => {
        if (d?.index === undefined) return;
        if (d.index > maxIndex) maxIndex = d.index;
      });

      // Seed the indexes for maxIndex + 1
      for (let i = 1; i <= maxIndex + 1; i++)
        this.indexes = [...this.indexes, i];
    },
  },
};
</script>

<style>
.slot-add-container {
  border: 1px solid #4caf50;
  width: 100%;
  border-radius: 5px;
}

.slot-reset-container {
  width: 100%;
}
</style>
